<template>
<div class="chapter">
<div class="inner_page">
<p class="SP" id="an"> </p>
<p class="FM-Head-fmh-1"><span href="#/xhtml/contents#c_an" title="Link target outside of Sample">Author’s Note</span></p>
<p class="FM-Text-No-Indent-fmtx1"><span class="ePub-I">The following is a work of nonfiction. All events are true as I remember them, though I am unapologetically prone to indiscriminate hyperbole, and some dialogue is approximated due to the passage of time. Most names and many identifying details have been changed, and some individuals are composites to further protect their identities.</span></p>
<p class="FM-Text-fmtx"><span class="ePub-I">A small number of scenes in the chapters “Schriftverkehr,” “Ereignis,” and “Schadenfreude” have appeared in a different form in </span>Slate<span class="ePub-I"> and on my personal website.</span></p>
<p class="FM-Text-fmtx"><span class="ePub-I">All translations from the German are my own.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// authorsnote.vue?7145e986